import React from "react";

import { Divider, Row, Surface, TextBody, TextLabel } from "../lib";
import { RatingScore } from "./rating-score";
import { formatMonth } from "../services";

export type ReviewItemProps = {
  score: number;
  date: Date | null;
  message: string;
};

export function ReviewItem({ score, date, message }: ReviewItemProps) {
  return (
    <Surface m="4">
      <Row.LR>
        <RatingScore value={score} />
        {!!date && <TextLabel>{formatMonth(date)}</TextLabel>}
      </Row.LR>

      <Divider />

      <TextBody>{message}</TextBody>
    </Surface>
  );
}
